import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxMaskModule } from 'ngx-mask';
import { ContactService } from 'src/app/features/contact';
import { MaterialModule } from 'src/app/material/material.module';
import { SharedModule } from '../../shared/shared.module';
import { CenterCardComponent } from './components/center-card/center-card.component';
import { LeftCardComponent } from './components/left-card/left-card.component';
import { RightCardComponent } from './components/right-card/right-card.component';
import {
  PromotionsComponent,
  PromotionsService,
} from './pages/public-card/modals';
import { PublicCardComponent } from './pages/public-card/public-card.component';
import { PublicCardRoutingModule } from './public-card.routing.module';

const COMPONENTS = [
  CenterCardComponent,
  LeftCardComponent,
  RightCardComponent,
  PublicCardComponent,
  PromotionsComponent,
];
const SERVICES = [HttpClient, ContactService, PromotionsService];

@NgModule({
  declarations: [COMPONENTS],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ClipboardModule,
    MaterialModule,
    PublicCardRoutingModule,
    NgxMaskModule.forRoot(),
    NgxQRCodeModule,
    TooltipModule.forRoot(),
    CarouselModule.forRoot(),
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http);
        },
        deps: [HttpClient],
      },
    }),
  ],
  providers: [SERVICES],
})
export class PublicCardModule {}
